import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

export var SearchLocation = function SearchLocation() {
  var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, SearchLocation);

  Object.assign(this, {
    id: json.id,
    lat: json.lat,
    lon: json.lon,
    locationName: json.name || json.main_text,
    placeId: json.place_id,
    mapBounds: json.map_bounds,
    timezone: json.timezone,
    type: json.type
  });
};